





























import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { EmailPreview } from "../domain";

// eslint-disable-next-line @typescript-eslint/no-var-requires
const Trumbowyg = require("vue-trumbowyg");
import "trumbowyg/dist/ui/trumbowyg.css";

@Component({
  components: { Trumbowyg: Trumbowyg.default }
})
export default class EmailPreviewDialog extends Vue {
  @Prop({ default: false }) value!: boolean;
  @Prop({ default: null }) content!: EmailPreview | null;

  rawContent = "";
  editorConfig = {};

  @Watch("content")
  onContent() {
    if (this.content) {
      this.rawContent = this.content.htmlBody;
    }
  }

  close() {
    this.$emit("input", false);
  }

  get lang() {
    return this.$store.state.lang.data;
  }
}
